import React, { useEffect } from "react";
import { Outlet, useNavigate } from 'react-router-dom';
import Header from "./Layout/Header/Header";
import Sidebar from "./Layout/Sidebar/Sidebar";
import Footer from "./Layout/Footer/Footer";

export default function Main() {
  const navigate = useNavigate();
  const isAuthenticated = localStorage.getItem('Atoken');
  
  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [isAuthenticated, navigate]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <>
    <div className="container-fluid page-body-wrapper">
      <Header />
      <Sidebar />

      <div className="main-panel" style={{height:'100vh',overflow:'auto'}}>
        <div className="content-wrapper">
          <Outlet />
        </div>
      <Footer />
      </div>
      </div>
    </>
  );
}
